import { z } from 'zod'

import { adDisplaysBeforeRefreshValues } from 'features/inventory/ad-unit/types/adDisplaysBeforeRefresh'
import { numberOfRotatingAdsValues } from 'features/inventory/ad-unit/types/numberOfRotatingAds'
import { unfilledRecoveryPrebidBehaviours } from 'features/inventory/types/unfilledRecoveryPrebidBehaviour'

import type { AdUnitForForm } from '../GeneralForm/hooks/useGetAdUnit'

const rotatingAdsQtySchema = z.enum(numberOfRotatingAdsValues)
const adDisplaysBeforeRefreshValuesSchema = z.enum(adDisplaysBeforeRefreshValues)

const invalidAdDisplaysBeforeRefreshError: string =
  'Ad displays before refresh must be between 1 and 5'
const invalidRotatingAdsQtyError: string = 'Number of rotating ads must be between 2 and 4'

export const schema = z.object({
  allowMultiformatEnabled: z.boolean(),
  baseAdUnitPath: z.string().optional(),
  customizeBaseAdUnitPathEnabled: z.boolean().default(false),
  customizePrebidBehaviour: z.boolean().default(false),
  desktopAdDisplaysBeforeRefresh: adDisplaysBeforeRefreshValuesSchema.default('2'),
  desktopSingleAdViewTime: z.number().int().min(2_000).default(5_000),
  id: z.string(),
  mobileAdDisplaysBeforeRefresh: adDisplaysBeforeRefreshValuesSchema.default('2'),
  mobileSingleAdViewTime: z.number().int().min(2_000).default(5_000),
  prebidBehaviourType: z.enum(unfilledRecoveryPrebidBehaviours).default('disabled'),
  rotatingAdsQty: rotatingAdsQtySchema.default('4'),
  unfilledRecoveryEnabled: z.boolean(),
})

export const schemaDefault = ({
  adUnitUnfilledRecovery: {
    allowMultiformatEnabled,
    baseAdUnitPath,
    customizeBaseAdUnitPathEnabled,
    customizePrebidBehaviour,
    desktopAdDisplaysBeforeRefresh,
    desktopSingleAdViewTime,
    mobileAdDisplaysBeforeRefresh,
    mobileSingleAdViewTime,
    prebidBehaviourType,
    rotatingAdsQty,
  },
  id,
  unfilledRecoveryEnabled,
}: AdUnitForForm): Schema => ({
  allowMultiformatEnabled,
  baseAdUnitPath,
  customizeBaseAdUnitPathEnabled,
  customizePrebidBehaviour,
  desktopAdDisplaysBeforeRefresh: adDisplaysBeforeRefreshValuesSchema.parse(
    String(desktopAdDisplaysBeforeRefresh),
    { error: () => invalidAdDisplaysBeforeRefreshError },
  ),
  desktopSingleAdViewTime,
  id,
  mobileAdDisplaysBeforeRefresh: adDisplaysBeforeRefreshValuesSchema.parse(
    String(mobileAdDisplaysBeforeRefresh),
    { error: () => invalidAdDisplaysBeforeRefreshError },
  ),
  mobileSingleAdViewTime,
  prebidBehaviourType,
  rotatingAdsQty: rotatingAdsQtySchema.parse(String(rotatingAdsQty), {
    error: () => invalidRotatingAdsQtyError,
  }),
  unfilledRecoveryEnabled,
})

export type Schema = z.infer<typeof schema>
